/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Top_UpInputs */

const cs_enum_top_up = /** @type {(inputs: Enum_Top_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobití`)
};

const en_enum_top_up = /** @type {(inputs: Enum_Top_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top up`)
};

/**
* | output |
* | --- |
* | "Top up" |
*
* @param {Enum_Top_UpInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_top_up = /** @type {((inputs?: Enum_Top_UpInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Top_UpInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_top_up(inputs)
	return cs_enum_top_up(inputs)
});